export default __webpack_public_path__ + "static/skills-30c696a71691f929ede24376d052fa8b.svg";